module.exports = "<div *ngIf=\"visible\" [style.background-color]=\"color\"></div>\n"